import API from '../../../../../services/api';

export const CLOSER_API = {
    getMetrics: async (search) => {
        return await API.get(`/closer/metrics?${search}`).then(res => res.data);
    },
}